import React, { useEffect } from "react";
import { selectLoading } from "features/admin/Products/productsAdminSlice";
import { batch, useDispatch, useSelector } from "react-redux";
import { RootState } from "store/rootReducer";
import GridTable from "../Common/GridTable";
import { useNavigate } from "react-router-dom";
import { deleteTag, fetchAllTags, selectAllTags } from "features/admin/Tags/tagsAdminSlice";
import { ColDef } from "@material-ui/data-grid";
import { setResponseMessage } from "features/admin/adminSlice";
interface AllTagsTableProps {}
const columns: ColDef[] = [
  { sortable: false, field: "title", headerName: "Текст", width: 300 },
  { sortable: false, field: "type", headerName: "Тип", width: 150 },
  {
    sortable: false,
    field: "textColor",
    headerName: "Цвят на текста",
    width: 150,
  },
  { sortable: false, field: "color", headerName: "Фон", width: 150 },
];

const TagsTable: React.FC<AllTagsTableProps> = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const tags = useSelector((state: RootState) => selectAllTags(state));
  const isLoading = useSelector((state: RootState) => selectLoading(state));
  useEffect(() => {
    dispatch(fetchAllTags());
  }, [dispatch]);

  const add = () => {
    navigate("/tags/add");
  };
  const refresh = () => {
    dispatch(fetchAllTags());
  };

  const edit = (id: string) => {
    const _refId = tags.find((item: { id: number }) => item.id === parseInt(id))?.refId;
    _refId && navigate(`/tags/edit/${_refId}`);
  };

  return (
    <GridTable
      add={add}
      refresh={refresh}
      edit={edit}
      data={tags}
      columns={columns}
      isLoading={isLoading}
      searchProperty="title"
    />
  );
};

export default TagsTable;
